import actionCreatorFactory from 'typescript-fsa';
import { AgentCommissionStatementSummary } from '../reducers/commission_statement_reducer';

const actionCreator = actionCreatorFactory('CommissionStatement');

export const GetAgentCommissionStatementDates = actionCreator.async<void, Date[]>('GET_AGENT_COMMISSION_STATEMENT_DATES');

export const GetAgentCommissionStatementSummary = actionCreator.async<Date, AgentCommissionStatementSummary>('GET_AGENT_COMMISSION_STATEMENT_SUMMARY');